export const homeObjOne = {
    id: 'home',
    lightBg: true,
    lightText: false,
    lightTextDesc:false,
    topLine:'Home',
    headLine: 'Web Developer/Designer.',
    description: 'Hey, i do both Freelancing and remote work , i m a Entry-level developer but i try my best to make clients happy with guiding them through all the steps of the project , you can check my work for more details. ',
    buttonLabel: 'Previous Projects ..',
    imgStart: false,
    img:require('../resource/Lost_online.svg').default,
    alt: 'imeg',
    dark: false,
    primary: false,
    darkText: true,
    headTo: 'projects',
}
export const homeObjTwo = {
    id: 'about',
    lightBg: false,
    lightText: true,
    lightTextDesc:true,
    topLine:'About',
    headLine: "Misty.",
    description: 'My name is Mohamed Marwan , i been working as a web dev since last year , i m still learning from every project i do , i would say my front-end skills are good but i still lack knowledge in the back-end part , i speak 3 languages : Arabic , French and English ',
    buttonLabel: 'Services',
    imgStart: true,
    img:require('../resource/Filing_system.svg').default,
    alt: 'imeg',
    dark: true,
    primary: true,
    darkText: false,
    headTo: 'services',
}
